import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(theme => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
    },
    li: {
      listStyle: 'none',
    },
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    },
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
}));

const footers = [
  {
    title: 'Company',
    items: [
      {
        name: 'Blog',
        url: 'https://blog.chessvision.ai',
        external: true,
      },
      {
        name: 'Contact us',
        url: 'mailto:hello@chessvision.ai',
        external: true,
      },
    ],
  },
  {
    title: 'Features',
    items: [
      {
        name: 'Give us feedback',
        url: 'mailto:hello@chessvision.ai',
        external: true,
      },
    ],
  },
  {
    title: 'Products',
    items: [
      {
        name: 'eBook Reader',
        url: 'https://ebook.chessvision.ai/?utm_source=discord.chessvision.ai',
        external: true,
      },
      {
        name: 'Chrome Extension',
        url: 'https://chrome.google.com/webstore/detail/chessvisionai-chess-posit/johejpedmdkeiffkdaodgoipdjodhlld',
        external: true,
      },
      {
        name: 'Firefox Add-on',
        url: 'https://addons.mozilla.org/en-US/firefox/addon/chessvision-ai-for-firefox/',
        external: true,
      },
      {
        name: 'Android App',
        url: 'https://play.google.com/store/apps/details?id=ai.chessvision.scanner',
        external: true,
      },
      {
        name: 'iOS App',
        url: 'https://apps.apple.com/us/app/id1574933453',
        external: true,
      },
    ],
  },
  {
    title: 'Resources',
    items: [
      {
        name: 'Privacy Policy',
        url: 'https://chessvision.ai/discord-bot/privacy-policy.html',
        external: true,
      },
      {
        name: 'Terms of Use',
        url: 'https://ebook.chessvision.ai/terms',
        external: true,
      },
    ]
  },
];

const Copyright = () => {
  return (
    <Typography variant="body1" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://chessvision.ai">
        chessvision.ai
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const Footer = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="md" component="footer" className={classes.footer}>
      <Grid container spacing={4} justify="space-evenly">
        {footers.map(footer => (
          <Grid item xs={6} sm={3} key={footer.title}>
            <Typography variant="h6" color="textPrimary" gutterBottom>
              {footer.title}
            </Typography>
            <ul>
              {footer.items.map(item => (
                <li key={item.name}>
                  <Link href={item.url} target={item.external ? "_blank" : "_self"} variant="subtitle1" color="textSecondary">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </Grid>
        ))}
      </Grid>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default Footer;
